import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import SingleSlider from 'components/inputs/SingleSlider';
import { Text1Bold } from 'components/typography/Texts';
import { useHotDealsFilters } from 'providers/HotDealsFiltersProviders';

const Container = styled.div`
  width: 100%;
`;

const StyledSingleSlider = styled(SingleSlider)`
  margin-bottom: 15px;
`;

const INFINITY_THRESHOLD = 200;
const MILES_MIN_VALUE = 0;
const SLIDER_STEP = 1;

export const PickupAreaFilter = () => {
  const { t } = useTranslation('item');
  const { filters, updateFilters } = useHotDealsFilters();
  const [sliderValue, setSliderValue] = useState<number>(INFINITY_THRESHOLD);

  useEffect(() => {
    setSliderValue(filters.radius ?? INFINITY_THRESHOLD);
  }, [filters.radius]);

  const handleSliderChange = (value: number) => {
    if (value >= INFINITY_THRESHOLD) {
      updateFilters({ radius: undefined, deliveryType: 'PickUp', sortType: 'NEAREST' });
    } else {
      updateFilters({ radius: value, deliveryType: 'PickUp', sortType: 'NEAREST' });
    }
  };

  const resolveLabel = (value: number) => {
    if (value >= INFINITY_THRESHOLD) {
      return `∞ ${t('filters.mile', { count: value })}`;
    }
    return `${value} ${t('filters.mile', { count: value })}`;
  };

  return (
    <Container data-testid={'pickup-area-container'}>
      <Text1Bold data-testid={'pickup-area-title'}>{t('filters.pickup-area')}</Text1Bold>
      <StyledSingleSlider
        testId={'pickup-area-slider'}
        min={MILES_MIN_VALUE}
        value={sliderValue}
        step={SLIDER_STEP}
        max={INFINITY_THRESHOLD}
        resolveLabel={resolveLabel}
        onChangeCommitted={handleSliderChange}
        onChange={setSliderValue}
      />
    </Container>
  );
};
